import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '@huge-monorepo/portal/layout';
import { AuthGuardService } from '@huge-monorepo/portal/services';
import { UserRightsAuthGuardService } from '@huge-monorepo/portal/services';

const routes: Routes = [
  // {
  //   path: '',
  //   component: LoginPageComponent,
  //   pathMatch: 'full',
  // },
  {
    path: '',
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.SplashPageModule),
  },
  {
    path: 'Home',
    // component: LayoutComponent,
    data: { breadcrumb: 'Home' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.HomeModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'CDR',
    data: { breadcrumb: 'Data Usage' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.CdrModule),
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
  },
  {
    path: 'Contractors',
    component: LayoutComponent,
    data: { breadcrumb: 'Contractor Jobs' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.ContractorsModule),
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
  },
  {
    path: 'KeepAlive',
    data: { breadcrumb: 'Keep Alive' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.KeepalivePageModule),
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
  },
  {
    path: 'Mikrotik',
    data: { breadcrumb: 'Router Management' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.MikrotikModule),
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
  },
  {
    path: 'Relay',
    data: { breadcrumb: 'Transaction Monitoring' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.RelayModule),
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
  },
  {
    path: 'Teltonika',
    component: LayoutComponent,
    data: { breadcrumb: 'Teltonika' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.TeltonikaModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'Reports',
    component: LayoutComponent,
    data: { breadcrumb: 'Reports' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.ReportsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'Releases',
    component: LayoutComponent,
    data: { breadcrumb: 'Releases' },
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.ReleasesModule),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: 'mikrotik-devices',
  //   loadChildren: () => import('@huge-monorepo/portal/modules').then( m => m.MikrotikDevicesPageModule)
  // },
  // children: [
  //   // {
  //   //   path: 'KeepAlive',
  //   //   canActivate: [AuthGuardService],
  //   //   // component: LayoutComponent,
  //   //   loadChildren: () => import('@huge-monorepo/portal/modules').then(
  //   //       module => module.KeepalivePageModule
  //   //   )
  //   // },
  //   {
  //     path: "",
  //     canActivate: [AuthGuardService],
  //     // component: LayoutComponent,
  //     loadChildren: () =>
  //       import("@huge-monorepo/portal/modules").then(
  //         (m) => m.HomeModule
  //       ),
  //   },
  // {
  //   path: "Mikrotik",
  //   canActivate: [AuthGuardService],
  //   // component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.MikrotikModule
  //     ),
  // },
  // {
  //   path: "CDR",
  //   canActivate: [AuthGuardService],
  //   // component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.CdrModule
  //     ),
  // },
  // {
  //   path: "Relay",
  //   canActivate: [AuthGuardService],
  //   // component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.RelayModule
  //     ),
  // },
  // ]
  // },
  // {
  //   path: 'KeepAlive',
  //   component: LayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       canActivate: [AuthGuardService],
  //       // component: LayoutComponent,
  //       loadChildren: () => import('@huge-monorepo/portal/modules').then(
  //           module => module.KeepalivePageModule
  //       )
  //     },
  //   ]
  // },
  // {
  //   path: "Reports",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.ReportsModule),
  // },
  // {
  //   path: "Map",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.MapModule),
  // },
  // {
  //   path: "Devices",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.DevicesModule),
  // },
  // {
  //   path: "Alerts",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.AlertsModule),
  // },
  // {
  //   path: "AlertConfiguration",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.AlertConfigurationModule
  //     ),
  // },
  // {
  //   path: "Settings",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.SettingsModule),
  // },
  // {
  //   path: "Profile",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.ProfilePageModule),
  // },
  // {
  //   path: "ChangeSession",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.ChangeSessionPageModule),
  // },
  // {
  //   path: "LocationSettings",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.LocationSettingsModule
  //     ),
  // },
  // {
  //   path: "Chat/:id",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then((m) => m.ChatModule),
  // },
  // {
  //   path: "DeviceRingfenceLogs",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.DeviceLogsModule
  //     ),
  // },
  // {
  //   path: "UserManagement",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.UserManagementModule
  //     ),
  // },
  // {
  //   path: "Report/:id",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.ReportDetailsModule
  //     ),
  // },
  // {
  //   path: "Device/:id",
  //   canActivate: [AuthGuardService],
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.DeviceDetailsModule
  //     ),
  // },
  // {
  //   path: "ChangePassword",
  //   canActivate: [AuthGuardService],
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import("@huge-monorepo/portal/modules").then(
  //       (m) => m.ChangePasswordAuthModule
  //     ),
  // },
  // {
  //   path: 'change-session',
  //   loadChildren: () => import('@huge-monorepo/portal/modules').then( m => m.ChangeSessionPageModule)
  // },
  // {
  //   path: 'change-session',
  //   loadChildren: () => import('@huge-monorepo/portal/modules').then( m => m.ChangeSessionPageModule)
  // },

  {
    path: '**',
    loadChildren: () => import('@huge-monorepo/portal/modules').then((m) => m.NotFoundPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class AppRoutingModule { }
